<template>
  <section class="main">
    <ModuleSection>
      <p>Ihre Auswahlmöglichkeiten:</p>

      <div :class="`grid-${$store.getters.isB2b ? '1' : '2'}_xs-1-spaceBetween-equalHeight u-grid-small-gutter-vertical u-grid-small-gutter-horizontal`">
        <!-- quantity > 2 -->
        <slot
          v-if="$store.getters.getSelectedQty >= $store.getters.getOrderQtySize.xs.min"
        >
          <div class="col">
            <FancyChooser
              @click="$root.$emit('composerModal:open', 'ModalShippingIndividual')"
              :isSelected="selectionData.main.mode === 3"
              @hover="hover"
              :hasGlowingAnimation="selectionData.main.mode ? false : glowingOptions"
            >
              <template v-slot:title>Direktversand an Beschenkte</template>
              <template v-slot:description>
                {{ $store.getters.getSelectedQty }} Präsente an {{ $store.getters.getSelectedQty }} Adressen - Ausland möglich
                <br>
                ab 5,90 € pro Präsent
              </template>
              <template v-slot:icon>
                <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 31L2.31467 27.644C1.46364 26.5802 1 25.2584 1 23.896V17C1 16.4696 1.21071 15.9609 1.58579 15.5858C1.96086 15.2107 2.46957 15 3 15V15C3.53043 15 4.03914 15.2107 4.41421 15.5858C4.78929 15.9609 5 16.4696 5 17V22" stroke="#454F5B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M11 30.8188V26.8188C11.0005 25.6323 10.6493 24.4723 9.99067 23.4854L8.468 21.2001C8.33808 20.9834 8.16554 20.7954 7.96083 20.6474C7.75611 20.4994 7.52349 20.3945 7.27704 20.339C7.03059 20.2835 6.77545 20.2787 6.52706 20.3247C6.27868 20.3707 6.04222 20.4667 5.832 20.6068V20.6068C5.45249 20.8596 5.17867 21.2427 5.06223 21.6836C4.9458 22.1245 4.99481 22.5928 5.2 23.0001L7 26.0001" stroke="#454F5B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M27 31L29.6853 27.644C30.5364 26.5802 31 25.2584 31 23.896V17C31 16.4696 30.7893 15.9609 30.4142 15.5858C30.0391 15.2107 29.5304 15 29 15C28.4696 15 27.9609 15.2107 27.5858 15.5858C27.2107 15.9609 27 16.4696 27 17V22" stroke="#454F5B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M21 30.8188V26.8188C20.9995 25.6323 21.3507 24.4723 22.0093 23.4854L23.532 21.2001C23.6619 20.9834 23.8345 20.7954 24.0392 20.6474C24.2439 20.4994 24.4765 20.3945 24.723 20.339C24.9694 20.2835 25.2246 20.2787 25.4729 20.3247C25.7213 20.3707 25.9578 20.4667 26.168 20.6068C26.5475 20.8596 26.8213 21.2427 26.9378 21.6836C27.0542 22.1245 27.0052 22.5928 26.8 23.0001L25 26.0001" stroke="#454F5B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 2C10.3431 2 8.99997 3.34315 8.99997 5V12.4C8.98712 13.0762 9.24319 13.7298 9.71195 14.2173C10.1807 14.7048 10.8238 14.9863 11.5 15H21.5C22.1763 14.9867 22.8196 14.7053 23.2884 14.2177C23.7572 13.7301 24.0132 13.0763 24 12.4V4.6C24.0132 3.92371 23.7572 3.26987 23.2884 2.78228C22.8196 2.2947 22.1763 2.01331 21.5 2H12Z" stroke="#454F5B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M14 2H19V9H14V2Z" stroke="#454F5B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </template>
            </FancyChooser>
          </div>

          <div
            class="col"
          >
            <FancyChooser
              @click="$root.$emit('composerModal:open', 'ModalShippingBulk')"
              :isSelected="selectionData.main.mode === 4"
              @hover="hover"
              :hasGlowingAnimation="selectionData.main.mode ? false : glowingOptions"
            >
              <template v-slot:title>Sammelversand</template>
              <template
                v-if="selectionData.main.mode === 4"
                v-slot:description
              >
                <slot v-if="selectionData.bulk.multipleLocations">
                  Mehrere Standorte
                </slot>

                <slot v-else>
                  Ein Standorte
                </slot>

                <slot v-if="selectionData.bulk.international">
                  — Ausland
                </slot>

                <slot v-else>
                  — Deutschland
                </slot>

                <br>

                <a>Bearbeiten</a>
              </template>

              <template
                v-else
                v-slot:description
              >
                Ein oder mehrere Standorte — Ausland möglich
                <br>
                kostenfrei ab {{ $store.getters.getFreeBulkShippingDe }} Präsenten an eine Adresse innerhalb Deutschlands, sonst {{ humanPrice($store.getters.getPricesShipping.bulkDe) }} pro Präsent,
              </template>
              <template v-slot:icon>
                <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><g transform="matrix(1.3333333333333333,0,0,1.3333333333333333,0,0)"><path d="M12,12H2.625A1.914,1.914,0,0,0,.75,13.95V19.8a1.914,1.914,0,0,0,1.875,1.95h7.5A1.913,1.913,0,0,0,12,19.8V12" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M4.5 12H8.25V17.25H4.5z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M17.25,12V4.2a1.913,1.913,0,0,0-1.875-1.95h-7.5A1.914,1.914,0,0,0,6,4.2V12" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M9.75 2.25H13.5V7.5H9.75z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M12,12v7.8a1.914,1.914,0,0,0,1.875,1.95h7.5A1.913,1.913,0,0,0,23.25,19.8V13.95A1.913,1.913,0,0,0,21.375,12H12" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M15.75 12H19.5V17.25H15.75z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path></g></svg>
              </template>
            </FancyChooser>
          </div>

          <div
            class="col"
          >
            <FancyChooser
              @click="$root.$emit('composerModal:open', 'ModalShippingCombined')"
              :isSelected="selectionData.main.mode === 5"
              @hover="hover"
              :hasGlowingAnimation="selectionData.main.mode ? false : glowingOptions"
            >
              <template v-slot:title>Kombiversand</template>
              <template
                v-if="selectionData.main.mode === 5"
                v-slot:description
              >
                <slot v-if="selectionData.combined.international">
                  Direktversand an Beschenkte:
                  {{
                    selectionData.combined.splitting.national.single +
                    selectionData.combined.splitting.international.single.de +
                    selectionData.combined.splitting.international.single.eu +
                    selectionData.combined.splitting.international.single.ch_uk +
                    selectionData.combined.splitting.international.single.other
                  }}

                  <br>

                  Großversand: {{ selectionData.combined.splitting.international.bulk.de + selectionData.combined.splitting.international.bulk.other }}
                </slot>

                <slot v-else>
                  Direktversand an Beschenkte: {{ selectionData.combined.splitting.national.single }}

                  <br>

                  Großversand: {{ selectionData.combined.splitting.national.bulk }}
                </slot>

                <br>

                <a>Bearbeiten</a>
              </template>
              <template
                v-else
                v-slot:description
              >
                Einzel- und Großversand — Ausland möglich
              </template>
              <template v-slot:icon>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="32" width="32"><defs></defs><title>strategy-split</title><path d="M9.651,6a.553.553,0,0,1-.476-.834L11.524,1a.553.553,0,0,1,.952,0l2.35,4.165A.554.554,0,0,1,14.349,6Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5px"></path><path d="M6.412,10.94a.555.555,0,0,0-.589-.761l-4.6.647a.553.553,0,0,0-.365.882l2.792,3.707a.555.555,0,0,0,.955-.122l.9-2.176Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5px"></path><path d="M5.38,13.432c4.149,1.3,6.62,3.8,6.62,8.519v1.3" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5px"></path><path d="M17.588,10.94a.555.555,0,0,1,.589-.761l4.6.647a.553.553,0,0,1,.365.882l-2.792,3.707a.555.555,0,0,1-.955-.122l-.9-2.176Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5px"></path><path d="M18.62,13.432c-4.149,1.3-6.62,3.8-6.62,8.519v1.3" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5px"></path><line x1="12" y1="6" x2="12" y2="21.951" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5px"></line></svg>
              </template>
            </FancyChooser>
          </div>

          <div
            class="col"
            v-if="$store.getters.getSelectedQty >= $store.getters.getOrderQtySize.sm.min"
          >
            <FancyChooser
              @click="selectionData.main.mode = 6"
              :isSelected="selectionData.main.mode === 6"
              @hover="hover"
              :hasGlowingAnimation="selectionData.main.mode ? false : glowingOptions"
            >
              <template v-slot:title>Später festlegen</template>
              <template v-slot:icon>
                <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><g transform="matrix(1.3333333333333333,0,0,1.3333333333333333,0,0)"><path d="M0.75 14.25L0.75 23.25" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M.75,21.75h15a3,3,0,0,0-3-3H9a3,3,0,0,0-3-3H.75" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M6 18.75L9 18.75" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M7.684,12.816A8.25,8.25,0,1,1,17.021,17" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M14.25 3.75L14.25 9.75 18 9.75" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path></g></svg>
              </template>
            </FancyChooser>
          </div>
        </slot>
        <!-- /quantity > 2 -->

        <!-- else (quantity 1) -->
        <slot v-else>
          <div class="col">
            <FancyChooser
              @click="selectionData.main.mode = 1; scrollToComposerSection('_ModuleShippingSingle')"
              :isSelected="selectionData.main.mode === 1"
              @hover="hover"
              :hasGlowingAnimation="selectionData.main.mode ? false : glowingOptions"
            >
              <template v-slot:title>Direktversand an Beschenkte</template>
              <template v-slot:description>Geschenkfertig ohne Rechnung / Lieferschein</template>
              <template v-slot:icon>
                <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 31L2.31467 27.644C1.46364 26.5802 1 25.2584 1 23.896V17C1 16.4696 1.21071 15.9609 1.58579 15.5858C1.96086 15.2107 2.46957 15 3 15V15C3.53043 15 4.03914 15.2107 4.41421 15.5858C4.78929 15.9609 5 16.4696 5 17V22" stroke="#454F5B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M11 30.8188V26.8188C11.0005 25.6323 10.6493 24.4723 9.99067 23.4854L8.468 21.2001C8.33808 20.9834 8.16554 20.7954 7.96083 20.6474C7.75611 20.4994 7.52349 20.3945 7.27704 20.339C7.03059 20.2835 6.77545 20.2787 6.52706 20.3247C6.27868 20.3707 6.04222 20.4667 5.832 20.6068V20.6068C5.45249 20.8596 5.17867 21.2427 5.06223 21.6836C4.9458 22.1245 4.99481 22.5928 5.2 23.0001L7 26.0001" stroke="#454F5B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M27 31L29.6853 27.644C30.5364 26.5802 31 25.2584 31 23.896V17C31 16.4696 30.7893 15.9609 30.4142 15.5858C30.0391 15.2107 29.5304 15 29 15C28.4696 15 27.9609 15.2107 27.5858 15.5858C27.2107 15.9609 27 16.4696 27 17V22" stroke="#454F5B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M21 30.8188V26.8188C20.9995 25.6323 21.3507 24.4723 22.0093 23.4854L23.532 21.2001C23.6619 20.9834 23.8345 20.7954 24.0392 20.6474C24.2439 20.4994 24.4765 20.3945 24.723 20.339C24.9694 20.2835 25.2246 20.2787 25.4729 20.3247C25.7213 20.3707 25.9578 20.4667 26.168 20.6068C26.5475 20.8596 26.8213 21.2427 26.9378 21.6836C27.0542 22.1245 27.0052 22.5928 26.8 23.0001L25 26.0001" stroke="#454F5B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 2C10.3431 2 8.99997 3.34315 8.99997 5V12.4C8.98712 13.0762 9.24319 13.7298 9.71195 14.2173C10.1807 14.7048 10.8238 14.9863 11.5 15H21.5C22.1763 14.9867 22.8196 14.7053 23.2884 14.2177C23.7572 13.7301 24.0132 13.0763 24 12.4V4.6C24.0132 3.92371 23.7572 3.26987 23.2884 2.78228C22.8196 2.2947 22.1763 2.01331 21.5 2H12Z" stroke="#454F5B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M14 2H19V9H14V2Z" stroke="#454F5B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </template>
            </FancyChooser>
          </div>

          <div class="col">
            <FancyChooser
              @click="selectionData.main.mode = 2; scrollToComposerSection('_ModuleShippingSingle')"
              :isSelected="selectionData.main.mode === 2"
              @hover="hover"
              :hasGlowingAnimation="selectionData.main.mode ? false : glowingOptions"
            >
              <template v-slot:title>Versand an Sie</template>
              <template v-slot:description>Zur persönlichen Übergabe</template>
              <template v-slot:icon>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" height="32" width="32"><g transform="matrix(1.3333333333333333,0,0,1.3333333333333333,0,0)"><g><g><path d="M.75,12.47,10.86,2.35A1.56,1.56,0,0,1,12,1.89a1.61,1.61,0,0,1,1.13.47L23.25,12.47" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1.5px"></path><polyline points="20.04 9.26 20.04 22.11 3.96 22.11 3.96 9.25" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1.5px"></polyline><path d="M15.21,22.11V17.29a3.21,3.21,0,0,0-6.42,0v4.82" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1.5px"></path></g><circle cx="12" cy="8.59" r="2.14" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1.5px"></circle></g></g></svg>
              </template>
            </FancyChooser>
          </div>
        </slot>
        <!-- /else (quantity 1) -->
      </div>

      <slot v-if="!selectionData.main.mode">
        <div class="main__onboarding">
          <img
            :srcset="`
              ${require('@/assets/images/shipping-onboarding-example@2x.png')}?format=${webPFormat('png')}&width=988&quality=80&compression=4 988w,
              ${require('@/assets/images/shipping-onboarding-example@2x.png')}?format=${webPFormat('png')}&width=494&quality=80&compression=4 494w
            `"
            sizes="
              (max-width: 36em) 90vw,
              36em
            "
            :src="`${require('@/assets/images/shipping-onboarding-example@2x.png')}?format=${webPFormat('png')}&width=494&quality=80&compression=4`"
            alt="Lieferung Beispiele"
          >
        </div>
      </slot>

      <Notice v-if="selectionData.main.mode === 6">
        <p>Sie haben sich noch nicht entschieden? Gerne können Sie die gewünschten Lieferoptionen nach der Bestellung festlegen.</p>
      </Notice>
    </ModuleSection>
  </section>
</template>

<script>
import { UiMixin } from '@/mixins/UiMixin';
import { helperMixin } from '@/mixins/HelperMixin';
import { logicMixin } from '@/mixins/LogicMixin';

import ModuleSection from '@/components/Composer/ModuleSection';
import FancyChooser from '@/components/Composer/FancyChooser';
import Notice from '@/components/Composer/Notice';

export default {
  name: 'ModuleShippingMain',
  props: ['selectionData'],
  mixins: [UiMixin, helperMixin, logicMixin],
  components: {
    ModuleSection,
    FancyChooser,
    Notice
  },
  data () {
    return {
      glowingOptions: true
    };
  },
  methods: {
    hover (status) {
      status ? this.glowingOptions = false : this.glowingOptions = true;
    }
  }
};
</script>

<style lang="scss" scoped>
/**
 * Shipping Main
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Shipping's main options
 * @since 2021-08-30
**/

$component: 'main';

.#{$component} {

  &__onboarding {
    @include margin-bottom(- map-get($spacers, 4));
    pointer-events: none;

    img {
      @include imageRendering;
      display: block;
      width: 100%;
      max-width: unset;
      margin: 0;
      object-fit: fill;
    }
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
    &__onboarding {
      img {
        width: 60%;
        margin: 0 auto;
      }
    }
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
    &__onboarding {
      img {
        width: 70%;
        margin: 0 auto;
      }
    }
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
    &__onboarding {
      img {
        width: 100%;
        margin: 0 auto;
      }
    }
  }
}
</style>
